import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import React from 'react';
import { useI18n } from '@udemy-v2/i18n';
import { Icon } from '@udemy-v2/icons';
import styles from './alternate-redirect.module.scss';
export const ALTERNATE_REDIRECT_REASON = {
  UPGRADED: 'upgraded',
  UNSUPPORTED: 'unsupported'
} as const;
export type AlternateRedirectReason = (typeof ALTERNATE_REDIRECT_REASON)[keyof typeof ALTERNATE_REDIRECT_REASON];
export interface AlternateRedirectProps {
  details?: {
    reason: AlternateRedirectReason;
    sourceCourseTitle: string;
  };
}
export const AlternateRedirect = t0 => {
  const $ = _c(12);
  const {
    details
  } = t0;
  const {
    gettext,
    interpolate
  } = useI18n();
  if (!details) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className={styles["icon-container"]}><Icon className={styles.icon} glyph="info" size="medium" color="info" label="Info" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== details.reason || $[2] !== gettext) {
    t2 = details.reason === ALTERNATE_REDIRECT_REASON.UPGRADED && <div data-testid="course-alternate-reason-upgraded"><div className="ud-heading-md">{gettext("You have been redirected to the latest version of this course.")}</div><div className={classNames("ud-text-sm", styles.subtext)}>{gettext("If you have enrolled in an earlier version of this course, you can access it in \"my courses\".")}</div></div>;
    $[1] = details.reason;
    $[2] = gettext;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== details.reason || $[5] !== details.sourceCourseTitle || $[6] !== gettext || $[7] !== interpolate) {
    t3 = details.reason === ALTERNATE_REDIRECT_REASON.UNSUPPORTED && <div data-testid="course-alternate-reason-unsupported"><div className="ud-heading-md">{interpolate(gettext("%(title)s is not published on our platform at this time. You've been redirected to a similar course."), {
          title: details.sourceCourseTitle
        }, true)}</div></div>;
    $[4] = details.reason;
    $[5] = details.sourceCourseTitle;
    $[6] = gettext;
    $[7] = interpolate;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <div className={styles.container} role="alert">{t1}{t2}{t3}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};